// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"4ecc0e25","108":"2243424e","208":"7683f465","525":"d2389cfc","580":"b4e94d96","600":"58cca550","724":"9111d600","784":"ef0c80d5","828":"5e152f9a","864":"8374cb74","992":"e4ff05fc"}[chunkId] + ".chunk.js";
};